import { render, staticRenderFns } from "./ProfileDocs.vue?vue&type=template&id=40b84ccb"
import script from "./ProfileDocs.vue?vue&type=script&lang=js"
export * from "./ProfileDocs.vue?vue&type=script&lang=js"
import style0 from "./ProfileDocs.vue?vue&type=style&index=0&id=40b84ccb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports